export default __webpack_public_path__ + "static/images/d39fd628916c46314d9fb4c9153cb01c.png";